import React from 'react';
import { RcIcon } from '@ringcentral/juno';
import { Previous } from '@ringcentral/juno-icon';
import rcLogo from '@/assets/images/rc-logo.svg';
import {
  Actions,
  BackButton,
  Container,
  RcLogoImage,
  RcLogoLink,
} from './HeaderMobilePopup.sc';

export const HeaderMobilePopup = ({ onBack }) => {
  return (
    <Container>
      <RcLogoLink
        href="/apps"
        rel="noreferrer"
        aria-label="RingCentral App Gallery"
      >
        <RcLogoImage
          symbol={rcLogo}
          data-test-automation-id="mobile-header-popup-image"
        />
      </RcLogoLink>
      <Actions>
        <BackButton
          variant="plain"
          onClick={onBack}
          data-test-automation-id="mobile-header-back-btn"
        >
          <RcIcon
            symbol={Previous}
            size="medium"
            data-test-automation-id="mobile-header-back-icon"
          />
          Back
        </BackButton>
      </Actions>
    </Container>
  );
};
